import { apiRequest } from "./axiosInstance";


export const getTenants = async (params)=>{
    const response = await apiRequest({
        url: "/tenant/getTenants",
        method: "GET",
        params:params
      });
      return response?.data
}


export const createTenant = async (body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: "/tenant/createTenant",
      method: "POST",
      data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};